import React, {Component} from 'react';
import {connect} from 'react-redux';
import MerchantAction from '../../actions/MerchantAction';
import Preloader from '../Preloader';
import {Control, Form} from 'react-redux-form';

class ProfileEdit extends Component {
  state = {
    logoChosenText: '',
    backgroundChosenText: ''
  };

  componentDidMount() {
    this.props.getProfile();
  }

  handleSubmit(data) {
    this.props.save(data);
  }

  template(merchant) {
    return (
      <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Edit profile details</h3>
              </div>
              <div className="panel-body">
                <Form model="forms.profileForm" onSubmit={(data) => this.handleSubmit(data)}>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <div className="form-control">{merchant.email}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="owner_first_name">First name</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.owner_first_name"
                                  id="owner_first_name"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="owner_last_name">First name</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.owner_last_name"
                                  id="owner_last_name"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.password"
                                  id="password"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirm_password">Confirm password</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.confirm_password"
                                  id="confirm_password"/>
                  </div>
                  <div className="panel-control">
                    <button type="submit" className="btn btn-action">Save</button>
                    <a href="/#/profile" className="btn btn-default ml10">
                      Cancel
                    </a>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const merchant = this.props.merchant;
    if (merchant && !this.props.isBusy) {
      return this.template(merchant);
    } else {
      return <Preloader />
    }

  }
}


export default connect(
  state => ({
    merchant: state.forms.profileForm,
    isBusy: state.requestStatus
  }),
  dispatch => ({
    getProfile: () => {
      dispatch(MerchantAction.get());
    },
    save: (data) => {
      dispatch(MerchantAction.edit(data));
    },
    setForm: (data) => {
      dispatch({type: 'SET_PROFILE_FORM', payload: data});
    }
  })
)(ProfileEdit);



/** WEBPACK FOOTER **
 ** ./src/components/Profile/edit.js
 **/